import { useTranslation } from "react-i18next";

export default function Tabs({itemWidth,activeWidth,animationWidth,data,setActiveTab,activeTab}) {
    
    const {t, i18n} = useTranslation();

    return (
        <>
        <div className="bg-white mx-auto h-[40px] rounded-[40px] flex flex-nowrap shadow-[0_8px_24px_0_rgba(0,0,0,0.07)] cursor-pointer mt-[10px] relative" style={{width:`${(itemWidth*data?.length)+26}px`}}>
            <div className="absolute top-[1px] start-0 h-[38px] rounded-[40px] bg-darkBlue transition-transform" style={{width:`${activeWidth}px`,transform:i18n.language === 'ar' ? `translateX(-${activeTab*animationWidth}px)`: `translateX(${activeTab*animationWidth}px)`}}></div>
            {data?.map((tab,index)=>{
                return (<div key={`tab-${index}`} className={`whitespace-nowrap relative h-[40px] leading-[40px] text-center text-[15px] ltr:text-[12px] lg:text-[20px] ltr:lg:text-[16px] font-[300] transition-[color] ${activeTab === index ? 'text-white font-[600]' : ''}`} style={{width: activeTab === index ? activeWidth : itemWidth+'px'}} onClick={()=>setActiveTab(index)}>{tab}</div>)
            })}
        </div>
        </>
    )
}